import './App.scss';

import { useContext, useEffect, useState } from 'react';
import { cookie } from '@mvecom/common/utils/clientCookieManager';
import { stringToBoolean } from '@mvecom/common/utils/stringToBoolean';
import { LoginModal } from './components/Modals/LoginModal/LoginModal';
import { MvAgentCart } from './components/MvAgentCart/MvAgentCart';
import { MvAgentFavourites } from './components/MvAgentFavourites/MvAgentFavourites';
import { setupAuth0Session, setupSession } from './network/axios';
import { TranslationsContext, TranslationsState } from './providers/TranslationsProvider';
import { isCiamEnabled } from './utils/retailUnitsWithCiam';
import { authHelper } from './utils/auth';
import { Actions } from './actions/enums';
import { getCookieDomain } from './network/utils/getCookieDomain';
import { getRetailUnitAndLanguage } from './network/utils/getRetailUnitAndLanguage';
import { useLogoutBusinessCustomer } from './hooks/useLogoutBusinessCustomer';

const App = () => {
  const { translationsState, getTranslations } = useContext(TranslationsContext);
  const [loaded, setLoaded] = useState<Array<'cart' | 'favourites'>>([]);

  useLogoutBusinessCustomer();

  useEffect(() => {
    getTranslations();
  }, [getTranslations]);

  useEffect(() => {
    // Only used for CIAM
    if (loaded.includes('cart') && loaded.includes('favourites')) {
      if (stringToBoolean(cookie.get('auth0-logged-in'))) {
        cookie.del('auth0-logged-in', `/${getRetailUnitAndLanguage().retailUnit}`, getCookieDomain);
        globalThis.ikea.pubsub.publish(Actions.USER_LOGGED_IN);
      }
      if (stringToBoolean(cookie.get('auth0-logged-out'))) {
        cookie.del('auth0-logged-out', `/${getRetailUnitAndLanguage().retailUnit}`, getCookieDomain);
        globalThis.ikea.pubsub.publish(Actions.USER_LOGGED_OUT);
      }
    }
  }, [loaded]);

  useEffect(() => {
    globalThis.ikea.mvAgent = globalThis.ikea.mvAgent || {};
    //legacy
    (globalThis.ikea.mvAgent as unknown as { isUserLoggedIn: () => Promise<boolean> }).isUserLoggedIn = async () => {
      console.warn(
        'ikea.mvAgent.isUserLoggedIn is deprecated. Please use ikea.mvAgent.authentication.isLoggedIn instead.',
      );
      return isCiamEnabled ? (await setupAuth0Session()).isAuthenticated : (await setupSession()).isLoggedIn;
    };
    globalThis.ikea.mvAgent.authentication = authHelper();
  }, []);

  useEffect(() => {
    // Redirect old migrate-password URL to new profile-based URL
    const pathname = globalThis.location.pathname;
    const wrongUrlPattern = /^\/([a-z]{2})\/([a-z]{2})\/migrate-password\/?$/;
    const match = pathname.match(wrongUrlPattern);
    if (match) {
      const [, retailUnit, language] = match;
      const correctUrl = `/${retailUnit}/${language}/profile/migrate-password/`;
      globalThis.location.href = globalThis.location.origin + correctUrl + globalThis.location.search;
    }
  }, []);

  useEffect(() => {
    const agentLoaded = (agent: 'cart' | 'favourites') => () => {
      setLoaded((v) => [...v, agent]);
    };

    globalThis.ikea.pubsub.subscribe(Actions.CART_AGENT_LOADED, agentLoaded('cart'));
    globalThis.ikea.pubsub.subscribe(Actions.FAVOURITES_AGENT_LOADED, agentLoaded('favourites'));
  }, []);

  return (
    <>
      {translationsState === TranslationsState.DONE && (
        <>
          {process.env.NODE_ENV === 'development' && (
            <link rel="stylesheet" href="https://www.ikea.com/global/assets/fonts/en/fonts.css"></link>
          )}
          <MvAgentCart />
          <MvAgentFavourites />
          <LoginModal />
        </>
      )}
    </>
  );
};

export default App;
